const norwegianNumber = new Intl.NumberFormat("nb-NO", { maximumFractionDigits: 3 });

export const formatNumber = (value: number | null | undefined): string =>
  value == null ? "" : norwegianNumber.format(value);
